module.exports = __webpack_public_path__ + "img/f24abf9.jpg";